// Copyright Epic Games, Inc. All Rights Reserved.

import {getTopLevelDomain} from '@wf-components/common-components-consumer';

export const isRelative = (href?: string): boolean => {
	return Boolean(href?.startsWith('/')) && !href?.startsWith('//');
};

export const isAbsolute = (href?: string): boolean => {
	return Boolean(href?.indexOf('http') === 0) || Boolean(href?.startsWith('//'));
};

export const isMailTo = (href?: string): boolean => {
	return Boolean(href?.indexOf('mailto:') === 0);
};

export const isLauncher = (href?: string): boolean => {
	return Boolean(href?.indexOf('com.epicgames.launcher:') === 0);
};

export const isBrowser = () => {
	return typeof window !== 'undefined';
};

export const isTalonEnabled = () => {
	return (
		isBrowser() &&
		!!window.talon &&
		String(process.env.NEXT_PUBLIC_TALON_DISABLED)?.toLowerCase() !== 'true' &&
		!!process.env.NEXT_PUBLIC_TALON_FLOW_ID
	);
};

export const isTalonReady = () => {
	return isBrowser() && !!window.talon?.ready === true;
};

const EPIC_TLDS = new Set([
	'epicgames.com',
	'unrealengine.com',
	'twinmotion.com',
	'fortnite.com',
	'fab.com',
	'fallguys.com',
	'rocketleague.com',
	'metahuman.com',
	'realityscan.com',
	'kidswebservices.com',
	'epicgames.net'
]);

export const isSameOrigin = (href = ''): boolean => {
	if (!href) return false;

	if (isRelative(href)) {
		return true;
	}

	try {
		let cleanedHref = href;
		//prefix if missing protocol
		if (cleanedHref.startsWith('//')) {
			cleanedHref = `https:${cleanedHref}`;
		}
		const url = new URL(cleanedHref);
		if (!['http:', 'https:'].includes(url.protocol)) {
			return false;
		}
		return EPIC_TLDS.has(getTopLevelDomain(url.hostname));
	} catch {
		//Failed to parse href checking isSameOrigin()
		return false;
	}
};
